<template>
  <div class="table-details">
    <div class="page-header">
      <Breadcrumb>
        <BreadcrumbItem :to="`/nodes/${nodeID}/source?tabName=${prevTabName}`">
          {{ this.$t('streams.source') }}
        </BreadcrumbItem>
        <BreadcrumbItem>{{ accessTitle }}</BreadcrumbItem>
      </Breadcrumb>
      <div v-if="accessType === 'create'" class="mode-swtich">
        <label for="">{{ isTextMode ? $t('rules.textMode') : $t('rules.visualizationMode') }}</label>
        <i-switch v-model="isTextMode" @change="handleClearValidate"></i-switch>
      </div>
    </div>
    <Card shadow class="detail">
      <div v-if="isView" class="view-form">
        <Spin v-if="viewLoading" fix> </Spin>
        <Row>
          <i-col span="16">
            <div class="view-item">
              <label class="view-item--label">{{ $t('tables.tableName') }}: </label>
              <span>{{ viewForm.name }}</span>
            </div>
            <div class="view-item">
              <label class="view-item--label">{{ $t('tables.tableFields') }}: </label>
              <FieldsTable
                class="view-item--table"
                v-model="viewForm.tableFields"
                :isDetail="accessType === 'view'"
                disabled
              ></FieldsTable>
            </div>
            <template v-if="viewForm.options">
              <div v-for="(key, index) in Object.keys(viewForm.options)" :key="index" class="view-item">
                <label class="view-item--label">{{ key }}: </label>
                <span>{{ viewForm.options[key] }}</span>
              </div>
            </template>
          </i-col>
        </Row>
      </div>
      <Form v-else ref="record" :model="createForm" :rules="rules">
        <Row>
          <i-col v-if="isTextMode" span="16">
            <FormItem label="SQL" prop="sql">
              <div class="monaco-container sql">
                <Monaco
                  id="sql-data"
                  ref="sqlData"
                  v-model="createForm.sql"
                  lang="sql"
                  backgroud="#282a36"
                  :provider="dataTypeProvider"
                >
                </Monaco>
              </div>
            </FormItem>
          </i-col>
          <template v-else>
            <i-col span="16">
              <FormItem :label="$t('tables.tableName')" prop="name">
                <i-input v-model="createForm.name" size="large" :disabled="accessType === 'edit'"></i-input>
              </FormItem>
            </i-col>
            <i-col span="16">
              <i-checkbox v-model="isSchemaTable" class="single-checkbox">{{ $t('tables.isSchemaType') }}</i-checkbox>
            </i-col>
            <i-col v-if="isSchemaTable" span="16">
              <FormItem :label="$t('tables.tableFields')" prop="tableFields">
                <Tooltip
                  class="fields-table--tip"
                  :max-width="350"
                  transfer
                  :content="$t('tables.schemaTip')"
                  placement="right"
                >
                  <Icon type="md-help-circle"> </Icon>
                </Tooltip>
                <FieldsTable
                  v-model="createForm.tableFields"
                  :isDetail="accessType === 'edit'"
                  :tableFormat="createForm.format"
                ></FieldsTable>
              </FormItem>
            </i-col>

            <!-- tableType -->
            <i-col span="16">
              <FormItem :label="$t('tables.tableType')" prop="tableType">
                <a v-if="sourceInfo.helpUrl" :href="i18nLabel(sourceInfo.helpUrl)" target="_blank" rel="noopener">
                  <Icon type="md-document" />
                  {{ $t('common.documentation') }}
                </a>
                <!-- <Button
                  v-if="!isView"
                  class="top-create--btn action-add-btn"
                  icon="ios-create-outline"
                  type="primary"
                  ghost
                  @click="handleConfigSources"
                >
                  {{ $t('tables.sourceConfig') }}
                </Button> -->
                <ConfKeyTypesSeletor
                  v-model="createForm.tableType"
                  :category="category"
                  :params="isLookupTable ? { kind: kind } : {}"
                  @onChange="changeTableType"
                  @onSelected="handleSourceSelected"
                />
              </FormItem>
            </i-col>

            <!-- dataSource -->
            <!-- if `dataSource` isnot {}, show dataSource -->
            <i-col v-if="isShowDataSource" span="16">
              <FormItem prop="dataSource">
                <template slot="label">
                  <span>{{ i18nLabel(dataSourceInfo.label) || $t('tables.dataSource') }}</span>
                </template>
                <Tooltip
                  v-if="dataSourceInfo.hint"
                  max-width="250px"
                  class="field-help"
                  transfer
                  placement="top"
                  :content="i18nLabel(dataSourceInfo.hint)"
                >
                  <Icon v-if="dataSourceInfo.hint" type="md-help-circle" />
                </Tooltip>
                <i-input v-model="createForm.dataSource" size="large"></i-input>
              </FormItem>
            </i-col>

            <!-- confKey -->
            <i-col span="16">
              <FormItem :label="$t('tables.confKey')" prop="confKey">
                <Button
                  v-if="createForm.confKey"
                  icon="ios-create-outline"
                  type="primary"
                  ghost
                  class="top-create--btn action-add-btn"
                  @click="showConfKeyModel('edit')"
                >
                  {{ $t('configuration.editConfKey') }}
                </Button>
                <Button
                  v-if="createForm.tableType"
                  icon="ios-add"
                  type="primary"
                  ghost
                  class="top-create--btn action-add-btn"
                  @click="showConfKeyModel()"
                >
                  {{ $t('configuration.addConfKey') }}
                </Button>
                <ConfKeysSelector
                  ref="confKeysSelectorRef"
                  v-model="createForm.confKey"
                  :category="category"
                  :type="createForm.tableType"
                  @on-open-change="handleConfKeyOpen"
                />
              </FormItem>
            </i-col>
            <!-- format -->
            <i-col span="16">
              <FormItem :label="$t('tables.format')" prop="format">
                <FormatsSelector v-model="createForm.format" :formats="formatList" @onChange="changeFormat" />
              </FormItem>
            </i-col>
            <!-- format: custom -->
            <div v-if="createForm.format === 'custom'" class="format-content">
              <i-col span="16">
                <FormItem :label="$t('streams.schemaName')" prop="format">
                  <SchemasSelector
                    v-model="createForm.schemaName"
                    :type="createForm.format"
                    @onChange="changeSchemaName"
                    @clear="changeSchemaName"
                  />
                </FormItem>
              </i-col>
              <i-col span="16">
                <FormItem :label="$t('streams.schemaMessage')" prop="format">
                  <i-input v-model="createForm.schemaMessage" size="large"></i-input>
                </FormItem>
              </i-col>
            </div>
            <!-- format: delimited -->
            <i-col span="16" v-if="createForm.format === 'delimited'">
              <FormItem :label="$t('streams.delimited')" prop="delimited">
                <i-input v-model="createForm.delimited" size="large"></i-input>
              </FormItem>
            </i-col>

            <i-col v-if="kind === 'scan'" span="16">
              <FormItem :label="$t('tables.retainSize')" prop="retainSize">
                <InputNumber v-model="createForm.retainSize" size="large"></InputNumber>
              </FormItem>
            </i-col>
            <i-col v-if="kind === 'lookup'" span="16">
              <FormItem :label="$t('tables.key')" prop="key">
                <i-input v-model="createForm.key" size="large"></i-input>
              </FormItem>
            </i-col>
          </template>
          <i-col span="16" class="oper-col">
            <FormItem>
              <Button v-if="!isView" type="primary" @click="save">{{ $t('common.submit') }}</Button>
              <Button :style="!isView ? 'margin-left: 8px' : ''" type="text" @click="goBack">
                {{ $t('common.cancel') }}
              </Button>
            </FormItem>
          </i-col>
        </Row>
      </Form>
    </Card>

    <!-- conf key properties -->
    <ConfKeyPeopertiesModal
      v-if="createForm.tableType"
      ref="confKeyPropertiesRef"
      :modalVisible.sync="confKeyPropertiesVisible"
      :title="confKeyModalTitle"
      :category="category"
      :type="createForm.tableType"
      :confKeyName="createForm.confKey"
      :isEdit="isEditConfKey"
      @submit="submitedConfKey"
    />
  </div>
</template>

<script>
import nodeID from '@/mixins/nodeID'
import currentLang from '@/mixins/currentLang'
import Monaco from '@/components/Monaco'
import { createTable, viewTable, updateTable } from '@/api/table'
import { getMetadataByCategory } from '@/api/metadata'
import FieldsTable from './components/FieldsTable.vue'
import dataTypeProviderData from '../../utils/dataTypeProviderData'
import sqlKeyWords from '../../utils/sqlKeyWords'
import parseStreamSql, { parseWithStatement } from '../../utils/parseStreamSql'
import ConfKeyPeopertiesModal from '@/views/configuration/resource/components/ConfKeyPropertiesModal.vue'
import ConfKeyTypesSeletor from '@/components/ConfKeyTypesSeletor.vue'
import ConfKeysSelector from '@/components/ConfKeysSelector.vue'
import FormatsSelector from '@/components/FormatsSelector.vue'
import SchemasSelector from '@/components/SchemasSelector.vue'
import { RESOURCE_TYPE } from '@/utils/constants'

export default {
  name: 'TableDetails',
  components: {
    Monaco,
    FieldsTable,
    ConfKeyPeopertiesModal,
    ConfKeyTypesSeletor,
    ConfKeysSelector,
    FormatsSelector,
    SchemasSelector,
  },
  mixins: [nodeID, currentLang],
  data() {
    return {
      category: RESOURCE_TYPE.sources,
      kind: 'scan', // differentiate `scan` table and `lookup` table
      prevTabName: 'scanTable',
      accessType: this.$route.query.oper,
      isTextMode: false,
      isSchemaTable: false,
      viewLoading: false,
      viewForm: {},
      formatList: ['json', 'binary', 'delimited', 'custom'],
      confKeyList: [],
      sourceInfo: {},
      dataSourceInfo: {
        default: '',
        hint: null,
        label: null,
      },
      createForm: {
        name: '',
        tableType: '',
        dataSource: '',
        confKey: '',
        format: 'json',
        schemaName: '',
        schemaMessage: '',
        delimited: '',
        sql: '',
        retainSize: null, // scan table owner
        key: 'id', // loolupTable owner
      },
      confKeyPropertiesVisible: false,
      isEditConfKey: false,
    }
  },
  computed: {
    isView() {
      const { oper } = this.$route.query
      return oper === 'view'
    },
    accessTitle() {
      const { oper } = this.$route.query
      const operDict = {
        view: this.$t('common.view'),
        create: this.$t('common.create'),
        edit: this.$t('common.edit'),
      }
      return operDict[oper]
    },
    rules() {
      return {
        name: [
          { required: true, message: this.$t('common.fillContent') },
          { validator: this.validateTableName, trigger: 'blur' },
        ],
        sql: [{ required: true, message: this.$t('common.fillContent') }],
        tableFields: [{ required: true, message: this.$t('common.fillContent') }],
        tableType: [{ required: this.isLookupTable, message: this.$t('common.fillContent') }],
      }
    },
    dataTypeProvider() {
      return [...sqlKeyWords.sqlKeyWords, ...dataTypeProviderData]
    },
    confKeyModalTitle() {
      return !this.isEditConfKey
        ? this.$t('configuration.addSourceConfKey')
        : this.$t('configuration.editSourceConfKey')
    },
    isLookupTable() {
      return this.kind === 'lookup'
    },
    // if `datasource` key exists, but the value is empty, i.e. dataSource: {}, just hide the `dataSource`.
    isShowDataSource() {
      return !this.dataSourceInfo || Object.keys(this.dataSourceInfo).length
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const fromSource = from.name === 'sources'
      const tableForm = sessionStorage.getItem('tableForm')
      const isSchemaTable = sessionStorage.getItem('isSchemaTable')
      if (fromSource && tableForm && isSchemaTable) {
        vm.createForm = JSON.parse(tableForm)
        vm.isSchemaTable = isSchemaTable === 'true'
      } else if (vm.accessType !== 'create') {
        vm.loadDetail()
      }
      setTimeout(() => {
        sessionStorage.removeItem('tableForm')
        sessionStorage.removeItem('isSchemaTable')
      }, 2000)
    })
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      if (this.accessType === 'create') {
        // set `scan` table the default value of `tableType`
        if (this.kind === 'scan') {
          this.createForm.tableType = 'file'
          this.changeTableType(this.createForm.tableType)
        }
      }
    },
    // Compute tableFields
    parseStremFields({ TableFields, StreamFields }) {
      const parseData = (data) => {
        const tableFields = {}
        data.forEach((field) => {
          if (typeof field.FieldType === 'string') {
            tableFields[field.Name] = field.FieldType
          } else if (field.FieldType.Type === 'struct') {
            tableFields[field.Name] = parseData(field.FieldType.Fields)
          } else if (field.FieldType.Type === 'array') {
            tableFields[field.Name] = `${field.FieldType.Type}(${field.FieldType.ElementType})`
          }
        })
        return tableFields
      }
      const fileds = TableFields || StreamFields
      return parseData(fileds)
    },
    // table detail
    loadDetail() {
      const { tableName } = this.$route.params
      this.viewModalVisible = true
      this.viewLoading = true
      viewTable(this.nodeID, tableName)
        .then((res) => {
          const { data } = res
          const { Name, Options, TableFields, StreamFields } = data
          let tableFields = {}
          if (TableFields || StreamFields) {
            this.isSchemaTable = true
            tableFields = this.parseStremFields(data)
          } else {
            this.isSchemaTable = false
          }
          // view
          if (this.accessType === 'view') {
            this.viewForm = {
              name: Name,
              options: Options,
              tableFields,
            }
          } else {
            // edit
            const {
              DATASOURCE,
              datasource,
              CONF_KEY,
              confKey,
              FORMAT,
              format,
              TYPE,
              type,
              schemaid,
              schemaName,
              schemaMessage,
              delimiter,
              RETAIN_SIZE,
              retainSize,
              key,
            } = Options
            const schemaData = {}
            if (schemaid) {
              const schemaInfo = schemaid.split('.')
              schemaData.schemaName = schemaInfo[0]
              schemaData.schemaMessage = schemaInfo[1]
            }
            this.createForm = {
              name: Name,
              dataSource: DATASOURCE || datasource,
              confKey: CONF_KEY || confKey,
              format: FORMAT || format,
              tableType: TYPE || type,
              retainSize: RETAIN_SIZE || retainSize,
              key,
              tableFields,
              schemaName: schemaName || schemaData.schemaName || '',
              schemaMessage: schemaMessage || schemaData.schemaMessage || '',
              delimited: delimiter || '',
            }
          }
          this.viewLoading = false
        })
        .then(() => {
          // get `dataSource` label & value
          this.changeTableType(this.createForm.tableType, this.createForm.dataSource)
        })
        .catch(() => {
          this.viewLoading = false
        })
    },
    handleConfigSources() {
      sessionStorage.setItem('tableForm', JSON.stringify(this.createForm))
      sessionStorage.setItem('isSchemaTable', this.isSchemaTable)
      this.$router.push({
        path: `/nodes/${this.nodeID}/configuration`,
        query: {
          oper: this.accessType,
        },
      })
    },

    setDataSourceDefaultValue() {
      this.createForm.dataSource = ''
      this.dataSourceInfo = {
        default: '',
        hint: null,
        label: null,
      }
    },
    // change Source：set the type `dataSource` label && default value
    async changeTableType(type, dataSourceVal) {
      if (!type) {
        this.setDataSourceDefaultValue()
        return Promise.resolve()
      }
      try {
        const params = {
          nodeID: this.nodeID,
          name: type,
        }
        const res = await getMetadataByCategory(this.category, params)
        const { dataSource } = res.data

        // set `dataSource` label
        this.dataSourceInfo = dataSource || {
          default: '',
          hint: null,
          label: null,
        }

        // set `dataSource` value
        this.createForm.dataSource = dataSourceVal || dataSource?.default || ''

        return Promise.resolve(res)
      } catch (error) {
        this.setDataSourceDefaultValue()
        return Promise.reject(error)
      }
    },
    // change type: get stream type document link
    handleSourceSelected(data) {
      this.sourceInfo = data ? data.about : {}
    },
    handleConfKeyOpen(visible) {
      if (!this.createForm.tableType && visible) {
        this.$Message.warning(this.$t('tables.typeFirst'))
      }
    },
    // show conf Key properties modal: add | eadit
    showConfKeyModel(oper) {
      this.isEditConfKey = oper === 'edit'
      this.confKeyPropertiesVisible = true
    },
    submitedConfKey(data) {
      const { name } = data
      this.$refs.confKeysSelectorRef.reload(name)
    },
    // create table
    createTableByKind(data) {
      createTable(this.nodeID, this.kind, data).then((res) => {
        if (res.status === 201 && res.statusText === 'Created') {
          this.$Message.success(res.data)
        } else {
          this.$Message.success(this.$t('common.addSuccess'))
        }
        this.goBack()
      })
    },
    // update table
    updateTableByKind(data) {
      const params = {
        id: this.createForm.name,
        kind: this.kind,
      }
      updateTable(this.nodeID, params, data).then(() => {
        this.$Message.success(this.$t('common.editSuccess'))
        this.goBack()
      })
    },
    // change formta
    changeFormat(val) {
      this.createForm.schemaName = ''
      this.changeSchemaName()
      this.createForm.delimited = val === 'delimited' ? ',' : ''
    },
    changeSchemaName() {
      this.createForm.schemaMessage = ''
    },
    save() {
      this.$refs.record.validate((valid) => {
        if (!valid) {
          return
        }
        const data = {
          sql: '',
        }
        if (!this.isTextMode) {
          const {
            name,
            tableFields,
            confKey,
            format,
            dataSource,
            tableType,
            schemaName,
            schemaMessage,
            delimited,
            retainSize,
            key,
          } = this.createForm
          const $tableName = `CREATE TABLE ${name}`
          const $tableFields = tableFields || '()'
          let tableWithData = {
            DATASOURCE: dataSource,
            FORMAT: format,
            CONF_KEY: confKey,
            TYPE: tableType,
            KIND: this.kind || 'scan',
            ...(schemaName && schemaMessage && { SCHEMAID: `${schemaName}.${schemaMessage}` }),
            ...(format === 'delimited' && { DELIMITER: delimited }),
          }
          if (this.kind === 'scan') {
            tableWithData = {
              ...tableWithData,
              RETAIN_SIZE: retainSize,
            }
          } else if (this.kind === 'lookup') {
            tableWithData = {
              ...tableWithData,
              KEY: key,
            }
          }
          const $tableWith = parseWithStatement(tableWithData)
          data.sql = parseStreamSql`
              ${$tableName}
              ${$tableFields}
              ${$tableWith}
          `
        } else {
          data.sql = this.createForm.sql
        }
        if (this.accessType === 'create') {
          this.createTableByKind(data)
        } else {
          this.updateTableByKind(data)
        }
      })
    },
    validateTableName(rule, value, callback) {
      if (/\s/.test(value)) {
        callback(new Error(this.$t('tables.tableNameSpace')))
      } else {
        callback()
      }
    },
    handleClearValidate() {
      setTimeout(() => {
        this.$refs.record.resetFields()
      }, 1000)
    },
    goBackPage(tabName) {
      this.$router.push({
        name: 'source',
        params: {
          id: this.nodeID,
        },
        query: {
          tabName,
        },
      })
    },
    goBack() {
      this.goBackPage(this.prevTabName)
    },
  },
}
</script>
<style lang="scss">
.table-details {
  .ivu-card {
    .monaco-container.sql {
      margin-top: 43px;
    }
    .ivu-card-body {
      padding: 20px;
    }
    .ivu-checkbox-wrapper {
      margin-bottom: 8px;
    }
    .monaco-container.fields {
      height: 300px;
      margin-top: 8px;
    }
    .fields-table--tip {
      position: absolute;
    }
  }
  .action-add-btn {
    margin-left: 10px;
  }
  .field-help {
    position: relative;
    top: 2px;
    left: -2px;
  }
  .format-content {
    width: 100%;
  }
}
</style>
